import Timer from './Timer';
import { ObjectRequest } from './interfaces';

export default function copyRequest(request: ObjectRequest): ObjectRequest {
  const headers = new Map(request.headers);
  return { ...request, headers, timer: new Timer() };
}
